import React, {useState} from "react"
import {Button, Input, message, Popconfirm, Table, Typography} from "antd";
import Column from "antd/es/table/Column";
import {AiOutlineDelete, AiOutlineEye, BsPencil, IoMdClose} from "react-icons/all";
import Modal from "antd/es/modal/Modal";

function Lang({data, editLangFunc, deleteLangFunc, addNewSubjectModal, closeAddNewItemModal, addNewItemFunc, loading}) {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editModalData, setEditModalData] = useState(null);
  const [newLang, setNewLang] = useState(null);


  return (
      <div>
        <Table
            showSizeChanger={true}
            loading={loading}
            size={"middle"}
            dataSource={data}
            scroll={{y: "53vh"}}
            pagination={{position: ["none", "bottomLeft"]}}
            style={{width: '60%', padding: '3%'}}
        >
          <Column title="№" key="id" render={record => (
              <span>{record.id}</span>
          )}/>
          <Column title="Til" key="language" render={record => (
              <span>{record.name}</span>
          )}/>
          <Column title="Action" key="status" render={record => (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                width: '50%',
                justifyContent: 'space-between'
              }}>
                <BsPencil
                    className={"settingsDtmActionsIcon"}
                    onClick={() => {
                      setEditModalData(record)
                      setEditModalOpen(true)
                    }}/>
                <Popconfirm
                    title={"Tasdiqlash"}
                    okText={"O'chirish"}
                    cancelText={"Ortga"}
                    onConfirm={() => {
                      message.warn("O'chirish xizmati o'chgan!").then(() => {})
                      // deleteLangFunc(record)
                    }}>
                  <AiOutlineDelete className={"settingsDtmActionsIcon"}/>
                </Popconfirm>
                <AiOutlineEye className={"settingsDtmActionsIcon"}/>
              </div>
          )}/>
        </Table>
        <Modal
            visible={editModalOpen}
            closable={false}
            centered={true}
            onCancel={() => {
              setEditModalOpen(false)
            }}
            footer={null}
        >
          <div>
            <div
                onClick={() => {
                  setEditModalOpen(false)
                }}
                className={"settingsSubjectEditModalCloseIconCont"}>
              <IoMdClose/>
            </div>
            <Typography
                className={"settingsSubjectEditModalTitle"}>
              Yangilash
            </Typography>
            <div style={{
              display: 'flex',
              alignItems: "center",
              width: '80%',
              margin: '1vw auto'
            }}>
              <label className={"nameEditInputLabel"} htmlFor={"nameEditInput"}>Til</label>
              <Input
                  value={editModalData && editModalData.name}
                  id={"nameEditInput"}
                  onChange={(e) => {
                    setEditModalData({
                      ...editModalData,
                      name: e.target.value
                    })
                  }}/>
            </div>
            <div style={{
              display: "flex",
              justifyContent: "center"
            }}>
              <Button
                  type="primary"
                  className={"settingsEditModalSaveButton"}
                  onClick={() => {
                    if (editModalData.name) {
                      editLangFunc(editModalData)
                      setEditModalOpen(false)
                    } else {
                      message.error("Til kiritilmagan!").then(() => {})
                    }
                  }}>
                Saqlash
              </Button>
            </div>
          </div>
        </Modal>
        <Modal
            visible={addNewSubjectModal}
            closable={false}
            centered={true}
            onCancel={() => {
              closeAddNewItemModal()
            }}
            footer={null}
        >
          <div>
            <div
                onClick={() => {
                  closeAddNewItemModal()
                }}
                className={"settingsSubjectEditModalCloseIconCont"}>
              <IoMdClose/>
            </div>
            <Typography
                className={"settingsSubjectEditModalTitle"}>
              Til qo'shish
            </Typography>
            <div style={{
              display: 'flex',
              alignItems: "center",
              width: '80%',
              margin: '1vw auto'
            }}>
              <label className={"nameEditInputLabel"} htmlFor={"nameEditInput"}>Til</label>
              <Input
                  id={"nameEditInput"}
                  onChange={(e) => {
                    setNewLang(e.target.value)
                  }}/>
            </div>
            <div style={{
              display: "flex",
              justifyContent: "center"
            }}>
              <Button
                  type="primary"
                  className={"settingsEditModalSaveButton"}
                  onClick={() => {
                    if (newLang) {
                      addNewItemFunc(newLang)
                    } else {
                      message.error("Til kiritilmagan!").then(() => {})
                    }
                  }}>
                Saqlash
              </Button>
            </div>
          </div>
        </Modal>
      </div>
  )
}

export default Lang
